<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5102_17073)">
      <path
        d="M1.66675 1.66663L8.33341 1.66663L8.33341 18.3333H1.66675L1.66675 1.66663Z"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        d="M13.3335 3.33325L18.3335 3.33325L18.3335 18.3333H13.3335L13.3335 3.33325Z"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path d="M8.3335 5L13.3335 5L13.3335 18.3333H8.3335L8.3335 5Z" stroke="currentColor" stroke-width="1.5" />
      <path d="M10.8335 15.8333V13.3333" stroke="currentColor" stroke-width="1.5" />
      <path d="M15.8335 15.8333V12.5" stroke="currentColor" stroke-width="1.5" />
      <path d="M5 15.8333L5 11.6666" stroke="currentColor" stroke-width="1.5" />
    </g>
    <defs>
      <clipPath id="clip0_5102_17073">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
